import smsApi from '@/api/sms.api'
import Vue from 'vue'

const state = {
  sms: [],
  threadSms: [],
  smsTotalCount: 0,
  allSms: []
}

const getters = {
  searchSuggestions: (state) => {
    return state.allSms.map(x => x.message)
  }
}

const actions = {
  async loadAndUpdateSms ({ commit, rootState }, entityData) {
    console.info('loadAndUpdateSms ----------->')
    console.info('entityData === ', entityData)

    const onlyThisProject = true
    const skip = 0
    const take = 10
    const search = ''

    const response = await smsApi.getSms(entityData.tenant, entityData.projectId, onlyThisProject, skip, take, search)
    commit('SET_SMS', { sms: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadSms ({ commit, rootState }, { onlyThisProject, skip, take, search }) {
    const response = await smsApi.getSms(rootState.tenant.current, rootState.project.currentId, onlyThisProject, skip, take, search)
    commit('SET_SMS', { sms: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadAllSms ({ commit, rootState }, onlyThisProject) {
    const response = await smsApi.getSms(rootState.tenant.current, rootState.project.currentId, onlyThisProject)
    commit('SET_ALL_SMS', response.data)
  },

  async loadThreadSms ({ commit, rootState }, { threadId, onlyThisProject, skip, take, search }) {
    const response = await smsApi.getThreadSms(rootState.tenant.current, rootState.project.currentId, threadId, onlyThisProject, skip, take, search)
    commit('SET_THREAD_SMS', { sms: response.data })
  },

  async loadRelations ({ commit, rootState }, sms) {
    const response = await smsApi.getRelations(rootState.tenant.current, sms)
    return response.data
  },

  async createSms ({ commit, dispatch, rootState }, sms) {
    const projectId = rootState.project.currentId
    sms.projectId = projectId
    const response = await smsApi.createSms(rootState.tenant.current, projectId, sms)
    commit('CREATE_SMS', { sms: response.data, projectId: projectId })
  },

  async createThreadSms ({ commit, dispatch, rootState }, sms) {
    const projectId = rootState.project.currentId
    sms.projectId = projectId
    const response = await smsApi.createThreadSms(rootState.tenant.current, projectId, sms.threadId, sms)
    commit('CREATE_THREAD_SMS', { sms: response.data, projectId: projectId })
  },

  async reSendSms ({ commit, dispatch, rootState }, sms) {
    const projectId = rootState.project.currentId
    sms.projectId = projectId
    const response = await smsApi.reSendSms(rootState.tenant.current, projectId, sms.threadId, sms)
    commit('RESEND_SMS', { sms: response.data, projectId: projectId })
  },

  async pushSms ({ commit, dispatch, rootState }, sms) {
    const projectId = rootState.project.currentId
    sms.projectId = projectId
    sms.outgoing = true
    commit('PUSH_SMS', { sms: sms })
  },

  async popSms ({ commit }) {
    commit('POP_SMS')
  },

  async putSmsRead ({ rootState }, sms) {
    const projectId = rootState.project.currentId
    const smsId = sms.id
    await smsApi.putSmsRead(rootState.tenant.current, projectId, smsId)
  },

  async deleteSms ({ commit, getters, rootState }, sms) {
    await smsApi.deleteSms(rootState.tenant.current, sms)
    commit('DELETE_SMS', sms.id)
  }
}

const mutations = {
  SET_SMS (state, { sms, count }) {
    for (let i = 0; i < sms.length; i++) {
      sms[i].active = false
    }
    state.sms = sms
    state.smsTotalCount = count
  },

  SET_ALL_SMS (state, data) {
    state.allSms = data
  },

  SET_THREAD_SMS (state, { sms }) {
    state.threadSms = sms
  },

  CREATE_SMS (state, { sms }) {
    state.sms.unshift(sms)
    state.smsTotalCount += 1
  },

  CREATE_THREAD_SMS (state, { sms }) {
    state.threadSms.unshift(sms)
    state.smsTotalCount += 1
  },

  RESEND_SMS (state, { sms }) {
    state.threadSms.pop()
    state.threadSms.push(sms)
  },

  PUSH_SMS (state, { sms }) {
    state.threadSms.push(sms)
    state.smsTotalCount += 1
  },

  POP_SMS (state) {
    state.threadSms.pop()
    state.smsTotalCount -= 1
  },

  DELETE_SMS (state, id) {
    const key = state.threadSms.findIndex(el => el.id === id)
    Vue.delete(state.threadSms, key)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
